import {parseJSON} from 'date-fns';
import styles from '../RequestDetails.module.scss';
import Card from 'components/Card/Card';
import CardContent from 'components/CardContent';
import DateTimePicker from 'components/DateTimePicker';
import {useEffect, useState} from 'react';
import Select from 'components/Select';
import {format} from 'date-fns';
import {components} from 'react-select';
// import Button from 'components/Button';

interface Props {
  preference_date: string | Date | null;
  preference_time: string;
  onChangeTime: ({
    preference_date,
    preference_time,
  }: {
    preference_date: string | null;
    preference_time: string | null;
  }) => void;
}

const options = [
  {value: 'morning', label: 'Morning'},
  {value: 'afternoon', label: 'Afternoon'},
  {value: 'evening', label: 'Evening'},
];

function PreferenceTime({
  preference_date,
  preference_time,
  onChangeTime,
}: Props) {
  const createDateFromString = (dateString: string): Date => {
    const [year, month, day] = dateString.split('-').map(Number);
    // Create date with local time components to avoid UTC conversion issues
    return new Date(year, month - 1, day, 12, 0, 0);
  };
  const [date, setDate] = useState<Date | null>(() => {
    if (!preference_date) return null;
    return typeof preference_date === 'string'
      ? createDateFromString(preference_date)
      : preference_date;
  });
  const [time, setTime] = useState<string>(preference_time);

  useEffect(() => {
    if (typeof preference_date === 'string') {
      setDate(createDateFromString(preference_date));
    } else if (preference_date instanceof Date) {
      setDate(preference_date);
    }
  }, [preference_date]);

  const onChangeData = (date: any) => {
    setDate(date);

    onChangeTime({
      preference_date: date ? format(date, 'yyyy-MM-dd') : null,
      preference_time: time,
    });
  };

  const onChangeTimer = (nextVal: any) => {
    setTime(nextVal?.value || '');
    onChangeTime({
      preference_date: date ? format(date, 'yyyy-MM-dd') : null,
      preference_time: nextVal?.value || null,
    });
  };
  return (
    <Card>
      <CardContent px="sm" pt="none" pb="sm">
        <div className={styles.times}>
          <div>
            <div className={styles.label}>Preference date:</div>
            <div className={styles.calendarRoot}>
              <DateTimePicker
                showTimeSelect={false}
                dateFormat="MM/dd/yy E"
                value={date ? parseJSON(date) : undefined}
                onChange={onChangeData}
              />
            </div>
          </div>
          <div>
            <div className={styles.label}>Preference time:</div>
            <Select
              className={styles.select}
              onChange={onChangeTimer}
              placeholder={
                <span className="select-placeholder-text">Select time</span>
              }
              isClearable
              components={{
                DropdownIndicator: (props) =>
                  !time ? <components.DropdownIndicator {...props} /> : null,
              }}
              value={
                time
                  ? {value: time, label: time[0].toUpperCase() + time.slice(1)}
                  : null
              }
              options={options}
              size="md"
            />
          </div>
        </div>
        {/* <Button
          disabled={preference_date === date && preference_time === time}
          color="blue"
          onClick={onSave}
          className={styles.notify_action}
        >
          Save
        </Button> */}
      </CardContent>
    </Card>
  );
}

export default PreferenceTime;
